import axios from "axios";

export const getBooks = async (word) => {

  const data = axios.get(
    `${process.env.CONTENTLOAN_API_URL}/search/api/v1/filter?limit=5&word=${word}&contentType=book physical&order=AZ&page=0`
  );
  return data;
};